import PropTypes from 'prop-types';
import { camelize } from 'inflected';

export default function generateMenuPropTypes(items) {
    return items.reduce((all, item) => (
        { ...all, [`on${camelize(item)}Click`]: PropTypes.func }
    ), {});
}
